import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNLIST, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../@theme/services/clients.service'
import { TypesServices } from '../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../reps/shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../reps/shared/rep-editor-state.service'

@Component({
    selector: 'gd-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        KENDO_DROPDOWNS,
        KENDO_GRID,
        KENDO_INPUTS,
        KENDO_GRID_PDF_EXPORT,
        KENDO_GRID_EXCEL_EXPORT,
        KENDO_INDICATORS,
        KENDO_DIALOGS,
        KENDO_BUTTONS,
        KENDO_DROPDOWNLIST,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
    ]
})
export class ProductsComponent
  extends GridEditorBaseComponent
  implements OnInit
{
  public productNames: any[]
  public sponsors: any[]

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnInit() {
    this.initGrid()
  }

  initGrid(): void {
    this.typesService.getProductNames().subscribe((response) => {
      this.productNames = response
    })
    this.typesService.getSponsorsForProductClassFour().subscribe((response) => {
      this.sponsors = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const productName = formGroup.value
    productName.sponsorName = this.sponsors.find(
      (s) => s.sponsorId == productName.sponsorId,
    ).sponsorName
    this.typesService.submitProductNameUpdate(productName).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        productNameId: 0,
        productNameDesc: null,
        sponsorId: null,
        sponsorName: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(productName: any): UntypedFormGroup {
    return this.formBuilder.group({
      productNameId: [productName.productNameId],
      productNameDesc: [productName.productNameDesc, Validators.required],
      sponsorId: [productName.sponsorId, Validators.required],
      sponsorName: productName.sponsorName,
      active: productName.active,
    })
  }
}
